import React from "react";

const Footer = () => {
  return (
    <footer className="border-t bg-gray-50 py-12">
      <div className="container">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="space-y-4">
            <div className="flex items-center">
              <img 
                src="/lovable-uploads/99032d9c-f4f6-4d7e-8e3e-5fd2fdf43cc4.png" 
                alt="Okkio Logo" 
                className="h-8 w-20"
              />
            </div>
            <p className="text-sm text-gray-600">
              Empowering citizens to create safer communities through easy, secure crime reporting.
            </p>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase">Platform</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-gray-600 hover:text-navy-700">How it works</a></li>
              <li><a href="#" className="text-gray-600 hover:text-navy-700">Report a crime</a></li>
              <li><a href="#" className="text-gray-600 hover:text-navy-700">Success stories</a></li>
              <li><a href="#" className="text-gray-600 hover:text-navy-700">FAQ</a></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase">Company</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-gray-600 hover:text-navy-700">About us</a></li>
              <li><a href="#" className="text-gray-600 hover:text-navy-700">Careers</a></li>
              <li><a href="#" className="text-gray-600 hover:text-navy-700">Blog</a></li>
              <li><a href="#" className="text-gray-600 hover:text-navy-700">Contact</a></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-gray-600 hover:text-navy-700">Privacy Policy</a></li>
              <li><a href="#" className="text-gray-600 hover:text-navy-700">Terms of Service</a></li>
              <li><a href="#" className="text-gray-600 hover:text-navy-700">Data Policy</a></li>
              <li><a href="#" className="text-gray-600 hover:text-navy-700">Cookie Policy</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-200 pt-8 text-center text-sm text-gray-600">
          <p>&copy; {new Date().getFullYear()} Okkio. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
